import { SafeHtml } from '@angular/platform-browser';

export interface AlainLoadingConfig {
  /**
   * ç±»åï¼é»è®¤ï¼`spin`
   */
  type?: 'text' | 'icon' | 'spin' | 'custom';
  /**
   * æ¾ç¤ºææ¬ï¼é»è®¤ï¼`å è½½ä¸­...`
   */
  text?: string;
  icon?: {
    /** `nz-icon.nzType`ï¼é»è®¤ï¼`loading` */
    type?: string;
    /** `nz-icon.nzTheme`ï¼é»è®¤ï¼`outline` */
    theme?: 'fill' | 'outline' | 'twotone';
    /** `nz-icon.nzSpin`ï¼é»è®¤ï¼`true` */
    spin?: boolean;
  };
  custom?: {
    html?: string | SafeHtml;
    style?: object;
  };
  /**
   * å»¶è¿ï¼é»è®¤ï¼`0`
   */
  delay?: number;
}
